/* central place for runtime/build-time constants */   

// Base URL for backend API (override in production with REACT_APP_API_URL)
export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';